import "./HeroImageStyle.css";
import IntroImg from "../assets/live.png"
import { Link } from "react-router-dom";

import React from 'react'

const HeroImg = () => {
  return (
    <div className="hero">
      <div className="mask">
        <img className="intro-img" 
      src={IntroImg} alt="IntroImg"/>
      </div>
      <div className="content">
        <p>HI, WELCOME TO EKREAT.</p>
        <h2>YOUR EXPERIENCED</h2>
        <h1>IT CONSULTANT.</h1>
       <div>
        <Link to="/projects" className="btn">Projects</Link>
        <Link to="/contact" className="btn btn-light">Contact</Link>
       </div>
        <div/>
      </div>
    </div>
  )
}

export default HeroImg